import { AlertCircle } from '@/components/icons/barrel';
import usePrivyStatus from '@/lib/api/privy/get-privy-status';
import { PrivyStatus } from '@/types';
import { usePrivy, useWallets } from '@privy-io/react-auth';
import { useConnectedStandardWallets } from '@privy-io/react-auth/solana';
import { useEffect, useState } from 'react';

const isMaintenance = import.meta.env.VITE_MAINTENANCE === 'true';

export default function MaintenanceBanner() {
  const [shouldCheckStatus, setShouldCheckStatus] = useState(false);

  const { data: status } = usePrivyStatus({
    enabled: shouldCheckStatus,
  });

  const { ready } = usePrivy();
  const { ready: evmWalletsReady } = useWallets();
  const { ready: solanaWalletsReady } = useConnectedStandardWallets();

  useEffect(() => {
    const isReady = ready && evmWalletsReady && solanaWalletsReady;
    if (isMaintenance || isReady) return;
    const timeout = window.setTimeout(() => setShouldCheckStatus(true), 5_000);
    return () => {
      window.clearTimeout(timeout);
    };
  }, [ready, evmWalletsReady, solanaWalletsReady]);

  if (!isMaintenance && (!status || status === PrivyStatus.UP)) return;

  return (
    <div className="relative z-50 flex items-center gap-4 bg-brown px-6 py-3 sm:px-8">
      <AlertCircle size={14} />
      <p className="text-sm tracking-wider text-primary sm:text-base lg:text-lg">
        <strong>Under maintenance.</strong>
        &nbsp;Some parts of the website might not work as expected.
      </p>
    </div>
  );
}
